import React from 'react';
import { useLocation } from 'react-router-dom';
import CustomMenu from '../../v2-components/Antd/Menu';
import { OPTION_MENU } from './constants/option-menu.constant';
import { getOptionsMenu } from './utils/get-options-menu.utils';
import { Badge, Space } from 'antd';
import useNotificationStore from '../../v2-pages/notification/store/useNotificationStore';

// Helper function to determine selected menu key based on current path
const getSelectedKeyFromPath = (pathname) => {
	// Map paths to menu keys (only non-admin routes)
	if (pathname.startsWith('/quotation')) return ['followup-quotation'];
	if (pathname.startsWith('/v2/tracking')) return ['followup-purchase-orders'];
	if (pathname.startsWith('/preorder')) return ['followup-preorder'];
	if (pathname.startsWith('/v2/reserve')) return ['followup-request'];
	if (pathname.startsWith('/v2/claims')) return ['followup-claims'];
	if (pathname.startsWith('/v2/report')) return ['followup-reports'];
	if (pathname.startsWith('/v2/pharmacy-locals')) return ['pharmacy-locals'];
	if (pathname.startsWith('/v2/letters')) return ['pharmacy-letters'];
	if (pathname.startsWith('/migration2')) return ['products-migration'];
	if (pathname.startsWith('/v2/stock')) return ['products-stock'];
	if (pathname.startsWith('/v2/payments/token-pto-pago')) return ['payments-token'];
	if (pathname.startsWith('/v2/payments/resendPos')) return ['payments-pos'];
	if (pathname.startsWith('/v2/user-management')) return ['configuration-users-management'];
	if (pathname.startsWith('/v2/pharmacy-sliders')) return ['configuration-slider'];
	if (pathname.startsWith('/user-landing')) return ['configuration-landing'];
	if (pathname.startsWith('/v2/pharmacy-icons')) return ['configuration-icons'];
	if (pathname.startsWith('/carousel')) return ['configuration-carousel'];
	
	// Admin routes
	if (pathname.startsWith('/admin-quotation')) return ['followup-quotation-admin'];
	if (pathname.startsWith('/v2/admin-tracking')) return ['followup-purchase-orders-admin'];
	if (pathname.startsWith('/v2/admin-reserve')) return ['followup-request-admin'];
	if (pathname.startsWith('/v2/admin-claims')) return ['followup-claims-admin'];
	if (pathname.startsWith('/v2/admin-report')) return ['followup-reports-admin'];
	if (pathname.startsWith('/v2/admin-pharmacy-locals')) return ['pharmacy-locals-admin'];
	if (pathname.startsWith('/v2/admin-letters')) return ['pharmacy-letters-admin'];
	if (pathname.startsWith('/v2/admin-migration')) return ['products-migration-admin'];
	if (pathname.startsWith('/v2/admin-stock')) return ['products-stock-admin'];
	if (pathname.startsWith('/v2/admin-user-management')) return ['configuration-users-management-admin'];
	if (pathname.startsWith('/v2/admin-pharmacy-sliders')) return ['configuration-slider-admin'];
	if (pathname.startsWith('/landing')) return ['configuration-landing-admin'];
	if (pathname.startsWith('/v2/admin-pharmacy-icons')) return ['configuration-icons-admin'];
	if (pathname.startsWith('/admin-carousel')) return ['configuration-carousel-admin'];
	
	// Default home
	if (pathname === '/') return ['home-main'];
	
	return ['1']; // fallback to default
};

// Helper function to get the parent menu key that should be open
const getOpenKeysFromPath = (pathname) => {
	// Map paths to their parent menu keys
	if (pathname.startsWith('/quotation') || 
	    pathname.startsWith('/v2/tracking') ||
	    pathname.startsWith('/preorder') ||
	    pathname.startsWith('/v2/reserve') ||
	    pathname.startsWith('/v2/claims') ||
	    pathname.startsWith('/v2/report') ||
	    pathname.startsWith('/admin-quotation') ||
	    pathname.startsWith('/v2/admin-tracking') ||
	    pathname.startsWith('/v2/admin-reserve') ||
	    pathname.startsWith('/v2/admin-claims') ||
	    pathname.startsWith('/v2/admin-report')) {
		return ['followup-main'];
	}
	
	if (pathname.startsWith('/v2/pharmacy-locals') ||
	    pathname.startsWith('/v2/letters') ||
	    pathname.startsWith('/v2/admin-pharmacy-locals') ||
	    pathname.startsWith('/v2/admin-letters')) {
		return ['pharmacy-main'];
	}
	
	if (pathname.startsWith('/migration2') ||
	    pathname.startsWith('/v2/stock') ||
	    pathname.startsWith('/v2/admin-migration') ||
	    pathname.startsWith('/v2/admin-stock')) {
		return ['products-main'];
	}
	
	if (pathname.startsWith('/v2/payments')) {
		return ['payments-main'];
	}
	
	if (pathname.startsWith('/v2/user-management') ||
	    pathname.startsWith('/v2/pharmacy-sliders') ||
	    pathname.startsWith('/user-landing') ||
	    pathname.startsWith('/v2/pharmacy-icons') ||
	    pathname.startsWith('/carousel') ||
	    pathname.startsWith('/v2/admin-user-management') ||
	    pathname.startsWith('/v2/admin-pharmacy-sliders') ||
	    pathname.startsWith('/landing') ||
	    pathname.startsWith('/v2/admin-pharmacy-icons') ||
	    pathname.startsWith('/admin-carousel')) {
		return ['configuration-main'];
	}
	
	return ['sub1']; // fallback to default
};

export default function MenuOptions(props) {
	const store = useNotificationStore();
	const location = useLocation();
	const selectedKeys = getSelectedKeyFromPath(location.pathname);
	const openKeys = getOpenKeysFromPath(location.pathname);
	
	console.log('store', store.orderCount);
	console.log('store', store.claimsCount);

	// const checkMenu = getOptionsMenu(OPTION_MENU);

	// return (
	// 	<>
	// 		<CustomMenu defaultSelectedKeys={['1']} defaultOpenKeys={['sub1']} mode="inline" items={checkMenu} />
	// 	</>
	// );
	const modifiedOptionMenu = OPTION_MENU.map((menu) => {
		if (menu.key === 'followup-main') {
			return {
				...menu,
				children: menu.children.map((child) => {
					// Mapear los contadores según las claves del menú
					const countMap = {
						'followup-claims-admin': store.claimCount,
						'followup-claims': store.claimCount,
						'followup-purchase-orders-admin': store.orderCount,
						'followup-purchase-orders': store.orderCount,
						'followup-quotation-admin': store.quotationCount,
						'followup-quotation': store.quotationCount,
						'followup-preorder': store.preorderCount
					};

					// Si hay un contador para este elemento, agregar el Badge
					if (countMap[child.key] !== undefined) {
						return {
							...child,
							icon: (
								<Space>
									<Badge count={countMap[child.key]} />
								</Space>
							),
						};
					}
					return child;
				}),
			};
		}
		return menu;
	});

	const checkMenu = getOptionsMenu(modifiedOptionMenu);

	return <CustomMenu selectedKeys={selectedKeys} defaultOpenKeys={openKeys} mode="inline" items={checkMenu} />;
}
